import React from 'react';
import { Eyebrow } from '../ui/Eyebrow';
import { useBrand } from '../../contexts/BrandContext';
interface PageHeaderProps {
  eyebrow: string;
  title: string;
  intro?: string;
  aside?: React.ReactNode;
}
export function PageHeader({
  eyebrow,
  title,
  intro,
  aside
}: PageHeaderProps) {
  const {
    text
  } = useBrand();
  return <header className="bg-cream" data-id="element-322" data-mp="1r6p4l0rv1r7y">
      <div className="mx-auto max-w-shell px-6 pb-4 pt-14 md:px-8 md:pb-6 md:pt-20" data-id="element-323" data-mp="1r7qhzbwcmpsu">
        <Eyebrow className="text-brick" data-id="element-324" data-mp="1w4qk5bq2v8eo">{eyebrow}</Eyebrow>
        <div className="mt-5 grid gap-8 lg:grid-cols-[1.2fr_0.8fr] lg:items-end lg:gap-16" data-id="element-325" data-mp="213a8fis58wa7">
          <h1 className="max-w-3xl font-serif text-[2.75rem] leading-[1.02] text-ink md:text-[4.25rem]" data-id="element-326" data-mp="262wn7wnmekl4">
            {text(title)}
          </h1>
          {intro && <p className="max-w-xl text-base leading-relaxed text-ink-soft md:text-lg" data-id="element-327" data-mp="bp57cfep74h8">
              {text(intro)}
            </p>}
        </div>
        {aside && <div className="mt-10" data-id="element-328" data-mp="fr0iebmfkw87">{aside}</div>}
      </div>
    </header>;
}